import { CLINIC_RESULT_WARNING_THRESHOLD } from '../../../api/constant';

export const vetClinicTitle = 'Vet Clinics';

export const vetClinicIntro = `Add veterinary clinics that provide care for your pets. When you order items from Chewy Pharmacy, we'll work with your clinic on the prescription process.`;

export const removeClinicCheckerTitle = 'Would you like to remove this vet clinic?';

export const removeClinicCheckerText =
  'This clinic will be removed from your account and pet profiles';

export const undoText = 'Undo';

export const addClinicText = 'Add a Vet Clinic';

export const addNewClinicText = 'Add a New Vet Clinic';

export const searchVetText = 'Search for Your Veterinary Clinic';

export const vetSearchCriteriaText = 'Search by name, phone number, or ZIP code.';

export const onboardingVetText = `Give us your vet clinic's basic information, and we'll contact them to confirm the details.`;

export const searchText = 'Search';

export const narrowSearchTitle = `We found more than ${CLINIC_RESULT_WARNING_THRESHOLD} clinics.`;

export const narrowSearchText =
  'Try narrowing your search by adding more details about your vet clinic, like the state or ZIP code.';

export const noResultsTitle = "We didn't find any vet clinics.";

export const noResultsText =
  'None of the vet clinics in our system match your search. Try including more details about your vet clinic and search again.';

export const removeClinicSupportiveText = `In the future, we won’t work with this clinic on your pets’ prescriptions. Removing this clinic won’t affect your past or current Pharmacy orders.`;

export const removeClinicText = 'Remove Clinic';

export const cancelText = 'Cancel';

export const clinicSearchLabel = 'Clinic Search';

export const onboardingVetName = 'Clinic Name (Required)';

export const onboardingVetPhone = 'Phone Number (Required)';

export const zipCodeText = 'ZIP Code';

export const dontSeeClinicText = `Don't see your clinic? `;

export const messageMinimumCharacters = 'Enter at least 3 characters.';

export const noRecentOrdersImage =
  'https://static.chewy.com/lib/dft/1.2.0/illo/md/no-recent-orders-1x.png';

export const alreadyAssociatedText = 'This clinic is already associated with your account.';
